import React from 'react'

import OrderEntryCard, {
  IOrderEntryCardProps,
} from '../../components/OrderEntryCard'
import HazmatShipmentValidation from '../Hazmats/HazmatShipmentValidation'
import ColiGroup from './ColiGroup'
import DuplicateBarcodesValidation from './DuplicateBarcodesValidation'

interface TColisProps extends Omit<IOrderEntryCardProps, 'title' | 'children'> {
  disableColiCountChange?: boolean
}

const Colis = (props: TColisProps): React.ReactElement => {
  const { disableColiCountChange } = props

  return (
    <OrderEntryCard {...props} title={i18n.t('title_colis', 'Colis')}>
      <>
        <HazmatShipmentValidation />
        <DuplicateBarcodesValidation />
        <div>
          <ColiGroup disableColiCountChange={disableColiCountChange} />
        </div>
      </>
    </OrderEntryCard>
  )
}

export default Colis
